import * as yup from "yup";

export const validationSchema = yup.object({
  email:yup
  .string()
  .email("invalid_email_format")
  .required("field_required"),
  password:yup.string().required("field_required"),
});

export const LoginvalidationSchema = yup.object({
  usr_email: yup
    .string()
    .email("invalid_email_format")
    .required("field_required"),
  usr_password: yup.string().required("field_required"),
});


export const registerValidationSchema = yup.object({
  usr_fname: yup.string().required("field_required"),
  usr_lname: yup.string().required("field_required"),
  usr_phone: yup.string().required("field_required"),
  usr_email: yup
    .string()
    .email("invalid_email_format")
    .required("field_required"),
  usr_password: yup
    .string()
    .min(6, "password_must_be_at_least_6_characters")
    .required("field_required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("usr_password"), undefined], "passwords_mismatch")
    .required("field_required"),
});


export const verifyMailValidationSchema = yup.object({
  usr_email: yup
    .string()
    .email("invalid_email_format")
    .required("field_required"),
   
});

export const passwordValidationSchema = yup.object({
    usr_password: yup
    .string()
    .min(6, "password_must_be_at_least_6_characters")
    .required("field_required"),
    confirm_password: yup
    .string()
    .oneOf([yup.ref("usr_password"), undefined], "Passwords must match")
    .required("field_required"),
});

export const orbitValidationSchema = yup.object({
  orb_name: yup.string().required("field_required"),
  orb_description: yup.string().required("field_required"),
})

export const planetValidationSchema = yup.object({
  pro_name: yup.string().required("field_required"),
  pro_sub: yup.string().required("field_required"),
  // pro_contact_name: yup.string().required("required field"),
  // pro_contact_email: yup
  //   .string()
  //   .email("Enter a valid email")
  //   .required("required field"),
  // pro_contact_phone: yup.string().required("required field"),
  // pro_desc: yup.string().required("required field"),
  // pro_address: yup.string().required("required field"),
});


export const userInviteValidationSchema = yup.object({
  email: yup
  .string()
  .email("Enter a valid email")
  .when("usr_email", (usr_email: any, schema: any) => {
      return (!usr_email[0].length)
        ? schema.required("required field")
        : schema.notRequired();
    }),
    usr_desc: yup.string().required("required field"),
  });


export const membersValidationSchema = yup.object({
  usr_fname: yup.string().required("required field"),
  usr_lname: yup.string().required("required field"),
  usr_phone: yup.string().required("required field"),
  usr_email: yup
    .string()
    .email("Enter a valid email")
    .required("required field"),
});
